import MyTooltip from 'components/Onboarding/Mle/BusinessTab/MyTooltip';
import { redClassRemarksCond, replaceSquareBraces } from 'components/Onboarding/Mle/mle.utils';
import React from 'react'

const TitleComponent = ({ field, checkerRemarks, isEditMode, isReEditFlow, infoMsgs, fieldName, customClass = '', prefix=null, fieldDate=null }) => {
    let noShowRed = isReEditFlow && !!infoMsgs?.[replaceSquareBraces(fieldName)];
    return (
        <p className={`label ${customClass} ${redClassRemarksCond(checkerRemarks, fieldName, isEditMode, noShowRed)}`} >
            {field.label}
            {
                fieldDate &&
                <span className='time-stamp'> ({fieldDate})</span>
            }
            {field?.fieldValidations?.required && <span className="required-asterisk">*</span>}
            <MyTooltip checkerRemarks={checkerRemarks} fieldName={fieldName} prefix={prefix} />
        </p>
    );
}
export default TitleComponent
